<script setup>
import { watch, defineProps, defineEmits, defineExpose, ref, computed} from "vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "revisandoPedido",
    "pedidoDeCompra",
    "fornecedores",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:alteraFornecedor",
    "update:trocaFornecedor",
    "update:fornecedorVendedor",
]);

//==================================================================//
//=========================== Formulario ===========================//
//==================================================================//

const formulario = ref(null);

//==================================================================//
//====================== Altera Fornecedor =========================//
//==================================================================//

const alteraFornecedor = (update)=>{

    emits('update:alteraFornecedor',{
        ...props.pedidoDeCompra.fornecedor,
        ...update
    });

};

//==================================================================//
//======================= Troca Fornecedor =========================//
//==================================================================//

const trocaFornecedor = (novoFornecedor)=>{

    // Tentou Trocar o Fornecedor para o mesmo Fornecedor
    // Ignore a Troca
    if(novoFornecedor?.id == props?.pedidoDeCompra?.fornecedor?.id){
        return;
    }

    emits('update:trocaFornecedor',novoFornecedor);

};

//==================================================================//
//====================== Altera Fornecedor =========================//
//==================================================================//

const trocaFornecedorVendedor = (novoFornecedorVendedor)=>{

    // Tentou Trocar o Fornecedor Vendedor para o mesmo Fornecedor Vendedor
    // Ignore a Troca
    if(novoFornecedorVendedor?.id == props?.pedidoDeCompra?.fornecedorVendedor?.id){
        return;
    }

    emits('update:fornecedorVendedor',novoFornecedorVendedor);

};

//==================================================================//
//======================= Fornecedor Regras ========================//
//==================================================================//
    
const fornecedorRegras = [
    fornecedor => {
        if(fornecedor?.id){
            return true;
        }
        return 'Fornecedor é obrigatório.';
       
    }
];

//==================================================================//
//=================== Fornecedor Vendedor Regras ===================//
//==================================================================//

const fornecedorVendedorRegras = [
    vendedor => {
        if(vendedor?.id){
            return true;
        }
        return 'Vendedor é obrigatório.';
       
    }
];

//==================================================================//
//====================== Fornecedor Selecionado ====================//
//==================================================================//

const fornecedorSelecionado = computed(()=>{

    return props?.pedidoDeCompra?.fornecedor?.id

});


//==================================================================//
//====================== Desativa Fornecedor =======================//
//==================================================================//

const desativaFornecedor = computed(()=>{

    if(props?.pedidoDeCompra?.fornecedor?.status == "Leitura"){
        return true
    }

    if(props?.controlesDesativados == true){
        return true
    }

    return false;

});

//==================================================================//
//===================== Fornecedor Status Cor ======================//
//==================================================================//

const fornecedorStatusCor = computed(()=>{

    if(props?.pedidoDeCompra?.fornecedor?.status == "Leitura"){
        return "gray";
    }

    if(props?.pedidoDeCompra?.fornecedor?.status == "Salvo"){
        return "green";
    }

    if(props?.pedidoDeCompra?.fornecedor?.status == "Valido"){
        return "orange";
    }

    return "red"; 

});

//==================================================================//
//=================== Fornecedor Label Status ======================//
//==================================================================//

const fornecedorStatusLabel = computed(()=>{

    return props?.pedidoDeCompra?.fornecedor?.status || "Invalido";

});

//==================================================================//
//===================== Ao Trocar Fornecedor =======================//
//==================================================================//

const aoTrocarFornecedor = (fornecedor) => {

    trocaFornecedor(fornecedor)

};

//==================================================================//
//================= Ao Trocar Fornecedor Vendedor ==================//
//==================================================================//

const aoTrocarFornecedorVendedor = (fornecedorVendedor) => {

    trocaFornecedorVendedor(fornecedorVendedor);

};

//==================================================================//
//================= Desativa Fornecedor Vendedor ===================//
//==================================================================//

const desativaFornecedorVendedor = computed(()=>{

    if(desativaFornecedor.value){
        return true;
    }

    if(!fornecedorSelecionado.value){
        return true;
    }

    return false;

});

</script>

<template>

    <v-card
        class="c-fornecedor"
    >

        <v-card-title
            class="c-fornecedor__cabecalho"
        >

            <h3 class="c-label__titulo">

                Fornecedor

                <v-chip
                    v-show="props?.pedidoDeCompra?.id"
                    :color="fornecedorStatusCor"
                    dark
                >
                    {{fornecedorStatusLabel}}
                </v-chip>

            </h3>

        </v-card-title>

        <v-form
            ref="formulario"
            class="c-fornecedor__conteudo"
        >

            <v-autocomplete
                label="Fornecedor"
                class="c-campo__fornecedor"
                :value="props?.pedidoDeCompra?.fornecedor"
                :items="props.fornecedores"
                :item-props="true"
                :item-text="item => `${item.codigo} - ${item.nome}`"
                :rules="fornecedorRegras"
                :disabled="desativaFornecedor"
                outlined
                return-object
                @input="aoTrocarFornecedor"
            >

                <template v-slot:item="{ item }">
                    {{item.codigo}} - {{item.nome}}
                </template>

            </v-autocomplete>
            
            <v-select
                label="Vendedor"
                class="c-campo__vendedor"
                :value="props?.pedidoDeCompra?.fornecedorVendedor"
                :items="props?.pedidoDeCompra?.fornecedor?.vendedores"
                :item-props="true"
                :item-text="item => `${item.codigo} - ${item.nome}`"
                :rules="fornecedorVendedorRegras"
                :disabled="desativaFornecedorVendedor"
                @input="aoTrocarFornecedorVendedor"
                outlined
                return-object
            >

                <template v-slot:item="{ item }">
                    {{item.codigo}} - {{item.nome}}
                </template>

            </v-select>

        </v-form>

    </v-card>

</template>

<style scoped>

.c-fornecedor__cabecalho{
    display: grid;
    grid-template-columns: 1f;
    grid-template-rows: 1fr;
    gap: 10px;
    grid-template-areas: 
        "titulo";
}

.c-label__titulo {
    grid-area: titulo;
}

.c-fornecedor__conteudo{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "fornecedor fornecedorVendedor"
}

.c-campo__fornecedor {
    grid-area: fornecedor;
}

.c-campo__fornecedor >>> .v-input__slot{
    min-height: 48px;
}

.c-campo__fornecedorVendedor {
    grid-area: fornecedorVendedor;
}

</style>